import React from "react";
import styled from "@emotion/styled";
import Contacts from "../../assets/icon/contacts";
import { FaRegQuestionCircle } from "react-icons/fa";

const Container = styled.div`
  width: 770px;
  max-height: 90vh;
  padding: 0px 30px 30px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  color: #333333;

  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0px;
  margin-bottom: 30px;

  svg {
    color: #fb972e;
    margin-right: 8px;
  }
`;

const Cards = styled.div`
  display: grid;
  align-items: start;
  justify-content: center;
  overflow-y: scroll;

  width: calc(100% + 60px);
  max-height: 70vh;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  margin-left: -30px;
  padding: 0 30px;
`;

const StatusCard = styled.div`
  display: flex;
  flex-direction: column;
`;

const StatusName = styled.div`
  margin-top: 8px;
  margin-bottom: 15px;
  font-size: 1rem;
  font-weight: 600;
`;

const StatusDescription = styled.div`
  color: #707070;
  font-size: 0.9rem;
`;

const ContactsIcon = styled.div<{ backgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${(props) => props.backgroundColor};
`;

interface IStatusType {
  name: string;
  type: string;
  backgroundColor: string;
  iconColor: string;
  description: string;
}

export const STATUS_TYPES: Array<IStatusType> = [
  {
    name: "Confirmed",
    type: "confirmed",
    backgroundColor: "#EAF5E7",
    iconColor: "#75B85C",
    description:
      "This contact has opted into you list and confirmed their subscription by clicking on the email confirmation link.",
  },
  {
    name: "Not Confirmed",
    type: "not-confirmed",
    backgroundColor: "#F2F2F2",
    iconColor: "#AAAAAA",
    description:
      "This contact has either been imported as an existing contact from a previous platform or has not gone through the double opt-in process and is not required to confirm their subscription. This doesn't impact their ability to receive emails.",
  },
  {
    name: "Pending",
    type: "pending",
    backgroundColor: "#FDF5E1",
    iconColor: "#E3A600",
    description:
      "This contact has opted into your list and but has yet to confirm their subscription by clicking on the email confirmation link.",
  },
  {
    name: "Unsubscribed",
    type: "unsubscribed",
    backgroundColor: "#E8ECEF",
    iconColor: "#688195",
    description: "This contact has unsubscribed from your list",
  },
  {
    name: "Admin Unsubscribed",
    type: "admin-unsubscribed",
    backgroundColor: "#E8ECEF",
    iconColor: "#688195",
    description:
      "This contact has been unsubscribed by the account administrator.",
  },
  {
    name: "Bot Filled",
    type: "bot-filled",
    backgroundColor: "#FEEDE7",
    iconColor: "#E25723",
    description:
      "This contact has been identified as being bot filled on your sign up page and therefore isn't valid email contact.",
  },
  {
    name: "Suspended",
    type: "suspended",
    backgroundColor: "#F9E7E5",
    iconColor: "#C41700",
    description:
      "This contact has been suspended by the account administrator.",
  },
  {
    name: "Blocked",
    type: "blocked",
    backgroundColor: "#D6D6D6",
    iconColor: "#333333",
    description:
      "This contact has been blocked by the account administrator and can no longer opt-in with the same email address.",
  },
  {
    name: "Spam",
    type: "Spam",
    backgroundColor: "#F9E7E5",
    iconColor: "#E25723",
    description: `This contact has flagged one of your emails as "Spam". They no longer receive emails from you.`,
  },
  {
    name: "Suppressed",
    type: "Suppressed",
    backgroundColor: "#d4d3d3",
    iconColor: "#777575",
    description: `This contact appears on a BerserkerMail internal suppressed list because of a permanent delivery error or it showed evidence of malicious activity that would harm users of our platform. If you feel this status has been misapplied let us know so we can reconsider it.`,
  },
];

export default function StatusTypesModal() {
  return (
    <Container>
      <Title>
        <FaRegQuestionCircle />
        What do the email types mean?
      </Title>
      <Cards>
        {STATUS_TYPES.map((status) => {
          return (
            <StatusCard>
              <ContactsIcon backgroundColor={status.backgroundColor}>
                <Contacts color={status.iconColor} />
              </ContactsIcon>
              <StatusName>{status.name}</StatusName>
              <StatusDescription>{status.description}</StatusDescription>
            </StatusCard>
          );
        })}
      </Cards>
    </Container>
  );
}
